export default {
  de: {
    title: 'Variablen',
  },
};
